var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 399.428 399.428",
    style: {
      enableBackground: "new 0 0 399.428 399.428"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_491_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_495_",
    style: {
      fill: "#933EC5"
    },
    points: "299.564,252.223 299.265,252.125 299.541,252.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_496_",
    style: {
      fill: "#933EC5"
    },
    points: "245.842,234.765 246.058,234.822 245.852,234.755  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_497_",
    style: {
      fill: "#933EC5"
    },
    points: "228.182,180.519 291.912,189.779 399.428,154.877 261.385,134.818  228.172,180.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_498_",
    style: {
      fill: "#00D7DF"
    },
    points: "299.541,252.245 299.265,252.125 299.263,252.124 246.058,234.822  246.058,234.822 245.842,234.765 245.817,234.789 256.715,298.33 256.656,298.299 323.061,389.698  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_500_",
    style: {
      fill: "#64C37D"
    },
    points: "142.587,298.329 142.6,298.252 76.215,389.622 199.65,324.818  199.65,324.817 199.65,268.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_501_",
    style: {
      fill: "#FF9811"
    },
    points: "99.797,252.137 153.427,234.731 107.32,189.789 107.447,189.77 0,154.858  99.761,252.245 99.779,252.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_502_",
    style: {
      fill: "#EA348B"
    },
    points: "171.145,180.468 199.65,122.708 199.65,9.729 137.934,134.783  137.972,134.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_503_",
    style: {
      fill: "#F7AED1"
    },
    points: "228.172,180.499 261.385,134.818 199.65,9.729 199.65,122.708  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_504_",
    style: {
      fill: "#FFDA44"
    },
    points: "171.12,180.519 171.145,180.468 137.972,134.777 137.934,134.783  0,154.858 107.447,189.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_505_",
    style: {
      fill: "#91DC5A"
    },
    points: "153.427,234.731 99.797,252.137 99.779,252.239 76.215,389.622  142.6,298.252 153.485,234.789  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_506_",
    style: {
      fill: "#99EFF2"
    },
    points: "199.65,268.329 199.65,324.817 323.061,389.698 256.656,298.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_507_",
    style: {
      fill: "#7C84E8"
    },
    points: "291.982,189.789 245.852,234.755 246.058,234.822 299.564,252.223  399.428,154.877 291.912,189.779  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.87dbad5c304cbe9621f536ced432df6c.svg";
export { ForwardRef as ReactComponent };